import React from 'react';
import "./KeepButton.css";
import "./AllButtons.css";

export default function KeepButton({currentTotal, updateScore, resetCurrentTotal, nextTurn}) {
  function handleClick() {
    updateScore();
    resetCurrentTotal();
    nextTurn();
  }
  return (
    <>
    {currentTotal > 0 && <button className="KeepButton Button" onClick={handleClick}>Keep!</button>}
    </>
  )
}
